class JustifiedGallery {
  constructor(section) {
    this.section = section;
    this.gallery = section.querySelector('.justified-gallery');
    this.items = Array.from(section.querySelectorAll('.justified-gallery__item'));
    this.lightbox = section.querySelector('.justified-gallery-lightbox');
    this.lightboxImage = section.querySelector('.justified-gallery-lightbox__image');
    this.closeButton = section.querySelector('.justified-gallery-lightbox__close');
    this.prevButton = section.querySelector('.justified-gallery-lightbox__prev');
    this.nextButton = section.querySelector('.justified-gallery-lightbox__next');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    if (!this.gallery || this.items.length === 0) {
      return;
    }

    this.applySettings();
    this.bindEvents();
    this.layout();

    window.addEventListener('resize', () => {
      this.layout();
    });
  }

  applySettings() {
    const rowHeight = parseInt(this.section.dataset.rowHeight || '280', 10);
    const gap = parseInt(this.section.dataset.gap || '12', 10);

    this.gallery.style.setProperty('--justified-gallery-row-height', `${rowHeight}px`);
    this.gallery.style.setProperty('--justified-gallery-gap', `${gap}px`);
  }

  bindEvents() {
    this.items.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.openLightbox(index);
      });
    });

    this.closeButton.addEventListener('click', () => {
      this.closeLightbox();
    });

    this.prevButton.addEventListener('click', () => {
      this.showPrevious();
    });

    this.nextButton.addEventListener('click', () => {
      this.showNext();
    });

    this.lightbox.addEventListener('click', (event) => {
      if (event.target === this.lightbox) {
        this.closeLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!this.lightbox.classList.contains('is-active')) {
        return;
      }

      if (event.key === 'Escape') {
        this.closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        this.showPrevious();
      }

      if (event.key === 'ArrowRight') {
        this.showNext();
      }
    });
  }

  layout() {
    const galleryWidth = this.gallery.clientWidth;
    const gap = parseInt(this.section.dataset.gap || '12', 10);
    const targetRowHeight = parseInt(this.section.dataset.rowHeight || '280', 10);

    let row = [];
    let rowAspectRatio = 0;

    this.items.forEach((item) => {
      const image = item.querySelector('img');
      const width = image.naturalWidth || image.width || 1;
      const height = image.naturalHeight || image.height || 1;
      const aspectRatio = width / height;

      item.dataset.aspectRatio = aspectRatio;

      row.push(item);
      rowAspectRatio += aspectRatio;

      const rowWidth = rowAspectRatio * targetRowHeight + gap * (row.length - 1);

      if (rowWidth >= galleryWidth) {
        this.setRowLayout(row, rowAspectRatio, galleryWidth, gap);
        row = [];
        rowAspectRatio = 0;
      }
    });

    if (row.length > 0) {
      row.forEach((item) => {
        const aspectRatio = parseFloat(item.dataset.aspectRatio || '1');
        item.style.flexBasis = `${targetRowHeight * aspectRatio}px`;
        item.style.flexGrow = '0';
      });
    }
  }

  setRowLayout(row, rowAspectRatio, galleryWidth, gap) {
    const totalGap = gap * (row.length - 1);
    const rowHeight = (galleryWidth - totalGap) / rowAspectRatio;

    row.forEach((item) => {
      const aspectRatio = parseFloat(item.dataset.aspectRatio || '1');
      item.style.flexBasis = `${rowHeight * aspectRatio}px`;
      item.style.flexGrow = '0';
      item.style.height = `${rowHeight}px`;
    });
  }

  openLightbox(index) {
    this.currentIndex = index;
    this.updateLightboxImage();
    this.lightbox.classList.add('is-active');
    this.lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    this.lightbox.classList.remove('is-active');
    this.lightbox.setAttribute('aria-hidden', 'true');
    this.lightboxImage.src = '';
    document.body.style.overflow = '';
  }

  showPrevious() {
    this.currentIndex = this.currentIndex - 1;

    if (this.currentIndex < 0) {
      this.currentIndex = this.items.length - 1;
    }

    this.updateLightboxImage();
  }

  showNext() {
    this.currentIndex = this.currentIndex + 1;

    if (this.currentIndex >= this.items.length) {
      this.currentIndex = 0;
    }

    this.updateLightboxImage();
  }

  updateLightboxImage() {
    const item = this.items[this.currentIndex];
    const fullImage = item.dataset.fullImage;
    const alt = item.dataset.alt || '';

    this.lightboxImage.src = fullImage;
    this.lightboxImage.alt = alt;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-justified-gallery]').forEach((section) => {
    new JustifiedGallery(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('[data-justified-gallery]');

  if (section) {
    new JustifiedGallery(section);
  }
});